/**
 * article-table-accordion.js
 *
 * Article body tables come from the blog editor as raw HTML, sometimes with
 * heavy rowspan/colspan (e.g. zoning comparison charts) and no header row —
 * unreadable once squeezed into a scrolling table on any normal screen.
 *
 * This resolves any such table into a flat grid, groups rows by the first
 * (rowspan) column, and re-renders it as a stacked, expandable layout that
 * reads top-to-bottom instead of relying on column position. Simple tables
 * with no rowspan/colspan are left as-is — they already read fine as a table.
 */

(function () {
  function resolveGrid(table) {
    var rows = table.querySelectorAll('tr');
    var grid = [];

    rows.forEach(function (tr, rowIndex) {
      grid[rowIndex] = grid[rowIndex] || [];
      var colIndex = 0;

      Array.prototype.forEach.call(tr.children, function (cell) {
        var tag = cell.tagName;
        if (tag !== 'TD' && tag !== 'TH') return;

        while (grid[rowIndex][colIndex] !== undefined) colIndex++;

        var rowspan = parseInt(cell.getAttribute('rowspan'), 10) || 1;
        var colspan = parseInt(cell.getAttribute('colspan'), 10) || 1;
        var html = cell.innerHTML.trim();

        for (var r = 0; r < rowspan; r++) {
          grid[rowIndex + r] = grid[rowIndex + r] || [];
          for (var c = 0; c < colspan; c++) {
            grid[rowIndex + r][colIndex + c] = html;
          }
        }
        colIndex += colspan;
      });
    });

    return grid;
  }

  function textOf(html) {
    var el = document.createElement('div');
    el.innerHTML = html || '';
    return el.textContent.trim();
  }

  function dedupe(values) {
    return values.filter(function (val, i, arr) {
      return val !== undefined && val !== '' && (i === 0 || val !== arr[i - 1]);
    });
  }

  function sameValues(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function (val, i) { return val === b[i]; });
  }

  function groupRows(grid) {
    var groups = [];
    var current = null;

    grid.forEach(function (row) {
      if (!row || row.length < 2) return;

      var groupLabel = textOf(row[0]);
      if (!groupLabel) return;

      if (!current || current.label !== groupLabel) {
        current = { label: groupLabel, rows: [] };
        groups.push(current);
      }

      var values = dedupe(row.slice(2));
      var lastRow = current.rows[current.rows.length - 1];

      // A rowspan on the value columns means the same values apply to
      // multiple row labels (e.g. "Front" and "Street Side" share one
      // rule) — merge those into a single row instead of repeating the
      // same paragraph twice.
      if (lastRow && sameValues(lastRow.values, values)) {
        lastRow.label = lastRow.label + ', ' + textOf(row[1]);
        return;
      }

      current.rows.push({
        label: textOf(row[1]),
        values: values
      });
    });

    return groups;
  }

  function buildAccordion(groups) {
    var wrap = document.createElement('div');
    wrap.className = 'article-table-accordion';

    groups.forEach(function (group) {
      var details = document.createElement('details');
      details.className = 'article-table-group';
      details.open = true;

      var summary = document.createElement('summary');
      summary.className = 'article-table-group__title';
      summary.textContent = group.label;
      details.appendChild(summary);

      var body = document.createElement('div');
      body.className = 'article-table-group__body';

      group.rows.forEach(function (row) {
        var rowEl = document.createElement('div');
        rowEl.className = 'article-table-row';

        var labelEl = document.createElement('div');
        labelEl.className = 'article-table-row__label';
        labelEl.textContent = row.label || '';
        rowEl.appendChild(labelEl);

        row.values.forEach(function (val, i) {
          var valEl = document.createElement('div');
          valEl.className = 'article-table-row__value';

          // The source data has no column headers, so a second/third value
          // has no real name to give it — but showing it bare after the
          // first (often long) value reads as an orphaned fragment. A
          // neutral "Also:" tag at least marks it as a distinct, additional
          // condition instead of a continuation of the same sentence.
          if (i > 0) {
            var tag = document.createElement('span');
            tag.className = 'article-table-row__value-tag';
            tag.textContent = 'Also:';
            valEl.appendChild(tag);
          }

          var content = document.createElement('span');
          content.innerHTML = val;
          valEl.appendChild(content);

          rowEl.appendChild(valEl);
        });

        body.appendChild(rowEl);
      });

      details.appendChild(body);
      wrap.appendChild(details);
    });

    return wrap;
  }

  function isComplex(table) {
    return !!table.querySelector('td[rowspan], td[colspan], th[rowspan], th[colspan]');
  }

  document.querySelectorAll('.article__content table').forEach(function (table) {
    if (!isComplex(table)) {
      // Simple table — leave it as a real <table> (so its columns lay out
      // correctly) but wrap it so it can scroll instead of overflowing the
      // page if it's ever wider than its container.
      var wrap = document.createElement('div');
      wrap.className = 'article-table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
      return;
    }

    try {
      var grid = resolveGrid(table);
      var groups = groupRows(grid);
      if (!groups.length) return;

      var accordion = buildAccordion(groups);
      table.replaceWith(accordion);
    } catch (error) {
      console.log('article-table-accordion: leaving original table, transform failed', error);
    }
  });
})();
